/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'support';
const componentName = 'recent-tech-support-list';
const prefix = `${moduleName}.${componentName}`;

export const title = `${prefix}.title`;
export const emptyListPlaceholder = `${prefix}.emptyListPlaceholder`;
export const durationLabel = `${prefix}.durationLabel`;
export const sizeLabel = `${prefix}.sizeLabel`;
export const viewTranscriptTooltipLabel = `${prefix}.viewTranscriptTooltipLabel`;
export const packageCompletedWithWarningLabel = `${prefix}.packageCompletedWithWarningLabel`;
export const packageFailedLabel = `${prefix}.packageFailedLabel`;
export const packageStoppedLabel = `${prefix}.packageStoppedLabel`;
export const packageSuccessfulLabel = `${prefix}.packageSuccessfulLabel`;

export const ENGLISH = {
    [title]: 'Recent',
    [emptyListPlaceholder]: 'Tech support package has never been generated',
    [durationLabel]: 'Duration',
    [sizeLabel]: 'Size',
    [viewTranscriptTooltipLabel]: 'View Transcript',
    [packageCompletedWithWarningLabel]: 'Package completed with warnings',
    [packageFailedLabel]: 'Package Failed',
    [packageStoppedLabel]: 'Package came back with warnings',
    [packageSuccessfulLabel]: 'Completed Successfully',
};
